import { render, staticRenderFns } from "./ModalRetencao.vue?vue&type=template&id=699fc923&scoped=true"
import script from "./ModalRetencao.vue?vue&type=script&lang=js"
export * from "./ModalRetencao.vue?vue&type=script&lang=js"
import style0 from "./ModalRetencao.vue?vue&type=style&index=0&id=699fc923&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699fc923",
  null
  
)

export default component.exports